module.exports = __webpack_public_path__ + "static/media/angle-left.95260f4e.svg";